// extracted by mini-css-extract-plugin
export default {"submittedByContainer":"submittedByTab_submittedByContainer__K3Npw","section":"submittedByTab_section__oFO-V","section__heading":"submittedByTab_section__heading__j49tx"};